// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\locations\\\\PlanYourVisitSection\\\\components\\\\LocationIcon.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\locations\\PlanYourVisitSection\\components\\LocationIcon.tsx");
  import.meta.hot.lastModified = "1757171103328.2522";
}
// REMIX HMR END

export function LocationIcon() {
  return <div className="w-5 h-5 flex items-center justify-center">
      <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.125 8.26562C13.125 5.17969 10.5859 2.64062 7.5 2.64062C4.375 2.64062 1.875 5.17969 1.875 8.26562C1.875 8.77344 2.03125 9.51562 2.46094 10.5312C2.85156 11.4688 3.4375 12.5625 4.10156 13.6562C5.23438 15.4531 6.52344 17.1719 7.5 18.4219C8.4375 17.1719 9.72656 15.4531 10.8594 13.6562C11.5234 12.5625 12.1094 11.4688 12.5 10.5312C12.9297 9.51562 13.125 8.77344 13.125 8.26562ZM15 8.26562C15 11.7031 10.4297 17.7578 8.39844 20.2969C7.92969 20.8828 7.03125 20.8828 6.5625 20.2969C4.57031 17.7578 0 11.7031 0 8.26562C0 4.125 3.35938 0.765625 7.5 0.765625C11.6406 0.765625 15 4.125 15 8.26562ZM8.75 8.26562C8.75 7.60156 8.16406 7.01562 7.5 7.01562C6.79688 7.01562 6.25 7.60156 6.25 8.26562C6.25 8.96875 6.79688 9.51562 7.5 9.51562C8.16406 9.51562 8.75 8.96875 8.75 8.26562ZM4.375 8.26562C4.375 7.17188 4.96094 6.15625 5.9375 5.57031C6.875 5.02344 8.08594 5.02344 9.0625 5.57031C10 6.15625 10.625 7.17188 10.625 8.26562C10.625 9.39844 10 10.4141 9.0625 11C8.08594 11.5469 6.875 11.5469 5.9375 11C4.96094 10.4141 4.375 9.39844 4.375 8.26562Z" fill="#121212" fillOpacity="0.4" />
      </svg>
    </div>;
}
_c = LocationIcon;
var _c;
$RefreshReg$(_c, "LocationIcon");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;